import cn from "classnames"

import { ComponentLabel } from "./components/ComponentLabel"
import { ComponentShowMore } from "./components/ComponentShowMore"
import { CountLabelShowMore, Counter } from "./components/CountLabelShowMore"
import { DescriptionShowMore } from "./components/DescriptionShowMore"
import { PopoverShowMore } from "./components/PopoverShowMore"
import { TextLabelShowMore } from "./components/TextLabelShowMore"
import { TooltipShowMore } from "./components/TooltipShowMore"

import styles from "./ShowMore.module.scss"

import type { ShowMoreProps } from "."

export const ShowMore = (props: ShowMoreProps) => {
  const { children, label, id, classes = {} } = props
  const tooltipId = `${id || Date.now()}_templateId-showMore`

  return (
    <>
      <span data-template-id-show-more={tooltipId}>{label}</span>
      <div id={tooltipId} className={cn(styles.template, classes.template)}>
        {children}
      </div>
    </>
  )
}

ShowMore.Label = {
  Counter,
  Count: CountLabelShowMore,
  Text: TextLabelShowMore,
  Component: ComponentLabel
}

ShowMore.Tooltip = TooltipShowMore
ShowMore.Popover = PopoverShowMore
ShowMore.Component = ComponentShowMore
ShowMore.Description = DescriptionShowMore
